<template>
  <div :class="classModifiers">
    <div v-if="documentUploadInfoVisible" class="add-funds-bank-transfer__content">
      <account-upload-document
        :source="documentUploadSource"
        :isPending="documentUploadInfoPending"
        :theme="accountUploadDocumentTheme"
      ></account-upload-document>
    </div>
    <div v-else-if="isStep(STEPS.INITIAL)" class="add-funds-bank-transfer__content">
      <fee-waived-banner
        :class="noticePromoModifiers"
        level="success"
        :text="promoCodeDetail.friendlyDescription"
        v-if="showPromoNotification && false"
      >
      </fee-waived-banner>
      <div v-if="depositWarning" v-html="depositWarning" class="predictit-embedded-alert"></div>
      <fee-waived-banner
        :level="instantCreditBoxLevel"
        :text="instantCreditBoxMessage"
        v-if="showInstantCreditNotification && false"
      >
      </fee-waived-banner>
      <alert-box
        class="add-funds-bank-transfer__notice add-funds-bank-transfer__notice--error"
        level="warning"
        v-if="errorMessage"
      >
        <div v-html="errorMessage"></div>
      </alert-box>
      <template v-else>
        <div v-if="existingAccounts.length > 0" class="add-funds-bank-transfer__accounts">
          <div class="add-funds-bank-transfer__title">Use an Existing Account</div>
          <bank-account
            v-for="account in existingAccounts"
            :account="account"
            class="add-funds-bank-transfer__account"
            :key="account.authorizationId"
            @select="onSelect(account)"
            @remove="onRemove(account)"
          >
          </bank-account>
        </div>
        <div>
          <div
            :id="payWithMyBankId"
            ref="paywithmybank"
            class="add-funds-bank-transfer__paywithmybank"
          ></div>
        </div>
        <deposit-disclaimer :disclaimer="disclaimer"></deposit-disclaimer>
      </template>
    </div>
    <div v-else-if="isStep(STEPS.AMOUNT_CONFIRM)" class="add-funds-bank-transfer__content">
      <fee-waived-banner
        :class="noticePromoModifiers"
        level="success"
        :text="promoCodeDetail.friendlyDescription"
        v-if="showPromoNotification && false"
      >
      </fee-waived-banner>
      <fee-waived-banner
        :level="instantCreditBoxLevel"
        :text="instantCreditBoxMessage"
        v-if="showInstantCreditNotification && false"
      >
      </fee-waived-banner>
      <h4 class="add-funds-bank-transfer__cancel-title">
        <span class="add-funds-bank-transfer__cancel" @click.prevent="onLoadInitial"> Cancel </span>
      </h4>
      <bank-account
        v-if="account !== null"
        :removable="false"
        :showMessage="false"
        :account="account"
        class="add-funds-bank-transfer__account"
        @select="onLoadInitial"
      >
      </bank-account>
      <h5 class="form__title form__title--left form__title--margin">
        Deposit Amount (${{ minimumDepositAmount.toFixed(2) }} Minimum)
      </h5>
      <div class="row-x">
        <div class="small-12 column" v-if="amountHasError">
          <div class="add-funds-bank-transfer__error">
            {{ amountValidationMessage }}
          </div>
        </div>
        <div class="small-12 medium-4 column">
          <div class="input-group input-group--large">
            <span class="input-group__addon">&#36;</span>
            <input
              tabindex="1"
              class="input-group__input"
              v-model="amount"
              @input="$v.amount.$touch"
              :validation="$v.amount"
              @blur="handleAmountBlur"
            />
          </div>
        </div>
        <div class="small-12 medium-8 column">
          <div class="row-x">
            <div class="small-4 column" v-for="value in depositAmounts">
              <div
                class="button button--primary add-funds-bank-transfer__button"
                @click.prevent.stop="onUpdateAmount(value)"
              >
                <span class="add-funds-bank-transfer__button-plus">+</span> &#36;{{ value }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        :disabled="isConfirmDisabled"
        @click="onReviewAndConfirm"
        class="button button--large button--submit button--full-width add-funds-bank-transfer__confirm"
      >
        <span> Review and Confirm </span>
      </button>
      <deposit-disclaimer :disclaimer="disclaimer"></deposit-disclaimer>
    </div>
    <div v-else-if="isStep(STEPS.CONFIRM)" class="add-funds-bank-transfer__content">
      <h4 class="add-funds-bank-transfer__cancel-title">
        <span class="add-funds-bank-transfer__cancel" @click.prevent="onCancelConfirm">
          Cancel
        </span>
      </h4>
      <div class="add-funds-bank-transfer__info">
        <p class="add-funds-bank-transfer__info-large-para">Are you sure you want to deposit</p>
        <p class="add-funds-bank-transfer__info-amount">
          {{ infoAmount }}
        </p>
        <p class="add-funds-bank-transfer__info-large-para">using Online Banking?</p>
        <bank-account :account="account" :preview="true" class="add-funds-bank-transfer__account">
        </bank-account>
        <button
          :disabled="isConfirmDisabled"
          @click="onSubmit"
          class="button button--large button--submit button--full-width add-funds-bank-transfer__submit"
        >
          <span> Confirm And Deposit </span>
        </button>
        <deposit-disclaimer :disclaimer="disclaimer"></deposit-disclaimer>
      </div>
    </div>
    <div v-else-if="isStep(STEPS.PROCESSING)" class="add-funds-bank-transfer__content">
      <processing-transaction></processing-transaction>
    </div>
    <div v-else-if="isStep(STEPS.FINISHED_SUCCESS)" class="add-funds-bank-transfer__content">
      <div class="add-funds-bank-transfer__headline">
        <div class="add-funds-bank-transfer__icon">
          <img src="@/assets/icons/success-icon.svg" alt="" />
        </div>
        <h5
          class="add-funds-bank-transfer__icon-title add-funds-bank-transfer__icon-title--success"
        >
          Success!
        </h5>
        <deposited></deposited>
        <button
          @click="onSuccess"
          class="button button--large button--submit button--full-width add-funds-bank-transfer__submit"
        >
          <span> Done </span>
        </button>
      </div>
    </div>
    <div v-else-if="isStep(STEPS.FINISHED_FAILED)" class="add-funds-bank-transfer__content">
      <div class="add-funds-bank-transfer__headline">
        <div class="add-funds-bank-transfer__icon">
          <img src="@/assets/icons/fail-icon.svg" alt="" />
        </div>
        <div>
          <span v-if="currentStepData && currentStepData.error" v-html="currentStepData.error">
          </span>
          <span v-else>Unfortunately, we could not process your payment.</span>
        </div>
      </div>
      <button
        @click="onLoadInitial"
        class="button button--large button--submit button--full-width add-funds-bank-transfer__submit"
      >
        <span> Done </span>
      </button>
    </div>
    <div v-else-if="isStep(STEPS.FINISHED_EXPIRED)" class="add-funds-bank-transfer__content">
      <div class="add-funds-bank-transfer__headline">
        <h5 class="add-funds-bank-transfer__title add-funds-bank-transfer__title--warn">
          Bank Reauthorization Required
        </h5>
        <div class="add-funds-bank-transfer__expired-account">
          <bank-account class="add-funds-bank-transfer__account" :account="account" :preview="true">
          </bank-account>
        </div>
        <div>
          <p v-if="currentStepData && currentStepData.error" v-html="currentStepData.error"></p>
          <p v-else>Unfortunately, we could not process your payment.</p>
        </div>
        <div class="add-funds-bank-transfer__loader"></div>
        <div>
          <div
            :id="payWithMyBankId"
            ref="paywithmybank"
            class="add-funds-bank-transfer__paywithmybank add-funds-bank-transfer__paywithmybank--no-min-height"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./add-funds-bank-transfer.js"></script>
<style src="./add-funds-bank-transfer.scss" lang="scss"></style>
